module.exports = __webpack_public_path__ + "static/media/interior2.fd07b4f1.jpeg";